import { DashboardLayout } from 'components/layout/DashboardLayout';
import { useCustomSelector } from 'hooks';
import React, { useEffect, useState } from 'react';
import { useProductList } from './hooks/useProductList';
import "assets/scss/billingPortal/modules/reporting/productSummary.scss";
import { SubmenuTooltip } from "components/informational/SubmenuTooltip";
import { MoreButton } from "components/buttons/MoreButton";
import ic_export from "assets/images/ic_export.svg";
import { isArrayEmpty, isArrayNotEmpty } from 'functions';
import { Toaster } from 'components';
import useRecursiveBillingSetup from "dataflow/billingPortal/actions/useRecursiveBillingSetup.actions";
import useExportData from './hooks/useExportData';

export default function ProductSummaryReport(props) {
  const { userPermissions } = useCustomSelector("userManagementReducers");

  const { getMissingProducts_requesting, missingProducts } = useCustomSelector(
    "recursiveBillingSetup"
  );

  // User Group
  const { selectedProduct, productDisplay } = useProductList({
    ...props,
  });
  
  const { getMissingProducts } = useRecursiveBillingSetup();

  const exportData = useExportData();
  const [shouldExport, setShouldExport] = useState(false);

  useEffect(() => {
    if (!getMissingProducts_requesting && isArrayNotEmpty(missingProducts) && shouldExport) {
      exportData(missingProducts);
      setShouldExport(false); // Reset the flag after export
    }
  }, [getMissingProducts_requesting]);

  useEffect(() => {
    // Reset the flag when component mounts
    setShouldExport(false);
  }, []);

  return (
    <DashboardLayout
      headerTitle={"Product Summary Report"}
      bodyClassName={"product-summary-report"}
      body={
        <>
          <div className={"product-summary-report__headers"}>
            {/* Top Section */}
            <div
              className={
                "headers__top-section d-flex justify-content-between align-items-center"
              }
            >
              {/* Title */}
              <div className={"headers__title tableHeaderTitle "}>
                Product List
              </div>

              <SubmenuTooltip
                  menuItems={[
                      {
                          icon: ic_export,
                          label: "Export",
                          isDisabled: !(userPermissions?.Internal_UsageBillingReport_View),
                          onClick: () => {
                            if (isArrayEmpty(selectedProduct)) {
                              Toaster({
                                type: "info",
                                msg: "Please select at least one product to export.",
                              });
                            } else {
                              setShouldExport(true);
                              getMissingProducts(selectedProduct);
                            }
                          },
                      }
                  ]}
              >
                  <MoreButton
                      className={"action__more-actions"}
                      iconClassName={"more-actions__icon"}
                  />
              </SubmenuTooltip>
            </div>
          </div>

          <div className={"product-summary-report__content"}>
            {productDisplay}
          </div>
        </>
      }
    />
  );
}